module.exports = __webpack_public_path__ + "static/media/Omron.d1284484.png";